module.exports = __webpack_public_path__ + "img/Weapon_136.3f85ec01.png";